/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from '../../app/app.module';
import * as import2 from '@angular/common/src/common_module';
import * as import3 from '@angular/core/src/application_module';
import * as import4 from '@angular/platform-browser/src/browser';
import * as import5 from '@angular/forms/src/directives';
import * as import6 from '@angular/forms/src/form_providers';
import * as import7 from '@angular/http/src/http_module';
import * as import8 from '@angular/router/src/router_module';
import * as import9 from '../../app/app.routing';
import * as import10 from 'primeng/components/growl/growl';
import * as import11 from 'ng2-bootstrap/modal/modal.module';
import * as import12 from 'primeng/components/inputtext/inputtext';
import * as import13 from 'primeng/components/button/button';
import * as import14 from 'primeng/components/common/shared';
import * as import15 from '../../app/common/primeng/autocomplete/autocomplete';
import * as import16 from '@angular/common/src/localization';
import * as import17 from '@angular/core/src/application_init';
import * as import18 from '@angular/core/src/testability/testability';
import * as import19 from '@angular/core/src/application_ref';
import * as import20 from '@angular/core/src/linker/compiler';
import * as import21 from '@angular/platform-browser/src/dom/events/hammer_gestures';
import * as import22 from '@angular/platform-browser/src/dom/events/event_manager';
import * as import23 from '@angular/platform-browser/src/dom/shared_styles_host';
import * as import24 from '@angular/platform-browser/src/dom/dom_renderer';
import * as import25 from '@angular/platform-browser/src/security/dom_sanitization_service';
import * as import26 from '@angular/core/src/animation/animation_queue';
import * as import27 from '@angular/core/src/linker/view_utils';
import * as import28 from '@angular/platform-browser/src/browser/title';
import * as import29 from '@angular/forms/src/directives/radio_control_value_accessor';
import * as import30 from '@angular/forms/src/form_builder';
import * as import31 from '@angular/http/src/backends/browser_xhr';
import * as import32 from '@angular/http/src/base_response_options';
import * as import33 from '@angular/http/src/backends/xhr_backend';
import * as import34 from '@angular/http/src/base_request_options';
import * as import35 from '@angular/common/src/location/location';
import * as import36 from '@angular/router/src/url_tree';
import * as import37 from '@angular/router/src/router_outlet_map';
import * as import38 from '@angular/core/src/linker/system_js_ng_module_factory_loader';
import * as import39 from '@angular/router/src/router_preloader';
import * as import40 from 'ng2-bootstrap/positioning/positioning.service';
import * as import41 from 'ng2-bootstrap/component-loader/component-loader.factory';
import * as import42 from '../../app/common/errors/error.service';
import * as import43 from '../../app/services/common.service';
import * as import44 from '../../app/common/spinner/spinner.service';
import * as import45 from '../../app/services/CustomHttp.service';
import * as import46 from '../../app/services/login.service';
import * as import47 from '../../app/services/application.service';
import * as import48 from '../../app/services/LocalStorage.service';
import * as import49 from '../../app/common/OnlineServiceAuthGuard';
import * as import50 from 'primeng/components/common/api';
import * as import51 from '../../app/common/validation/FileValidation';
import * as import52 from '../../app/services/information.service';
import * as import53 from '@angular/core/src/di/injector';
import * as import54 from '../../$$_gendir/node_modules/ng2-bootstrap/modal/modal-backdrop.component.ngfactory';
import * as import55 from './app.component.ngfactory';
import * as import56 from '@angular/core/src/i18n/tokens';
import * as import57 from '@angular/core/src/application_tokens';
import * as import58 from '@angular/platform-browser/src/dom/events/dom_events';
import * as import59 from '@angular/platform-browser/src/dom/events/key_events';
import * as import60 from '@angular/core/src/zone/ng_zone';
import * as import61 from '@angular/platform-browser/src/dom/debug/ng_probe';
import * as import62 from '@angular/common/src/location/platform_location';
import * as import63 from '@angular/common/src/location/location_strategy';
import * as import64 from '@angular/router/src/url_handling_strategy';
import * as import65 from '@angular/router/src/route_reuse_strategy';
import * as import66 from '@angular/router/src/router';
import * as import67 from '@angular/core/src/console';
import * as import68 from '@angular/core/src/error_handler';
import * as import69 from '@angular/platform-browser/src/dom/dom_tokens';
import * as import70 from '@angular/platform-browser/src/dom/animation_driver';
import * as import71 from '@angular/core/src/render/api';
import * as import72 from '@angular/core/src/security';
import * as import73 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import74 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import75 from '@angular/http/src/interfaces';
import * as import76 from '@angular/http/src/http';
import * as import77 from '@angular/core/src/linker/ng_module_factory_loader';
import * as import78 from '@angular/router/src/router_config_loader';
import * as import79 from '@angular/router/src/router_state';
class AppModuleInjector extends import0.NgModuleInjector<import1.AppModule> {
  _CommonModule_0:import2.CommonModule;
  _ApplicationModule_1:import3.ApplicationModule;
  _BrowserModule_2:import4.BrowserModule;
  _InternalFormsSharedModule_3:import5.InternalFormsSharedModule;
  _FormsModule_4:import6.FormsModule;
  _ReactiveFormsModule_5:import6.ReactiveFormsModule;
  _HttpModule_6:import7.HttpModule;
  _ROUTER_FORROOT_GUARD_7:any;
  _RouterModule_8:import8.RouterModule;
  _AppRoutingModule_9:import9.AppRoutingModule;
  _GrowlModule_10:import10.GrowlModule;
  _ModalModule_11:import11.ModalModule;
  _InputTextModule_12:import12.InputTextModule;
  _ButtonModule_13:import13.ButtonModule;
  _SharedModule_14:import14.SharedModule;
  _AutoCompleteModule_15:import15.AutoCompleteModule;
  _AppModule_16:import1.AppModule;
  __LOCALE_ID_17:any;
  __NgLocalization_18:import16.NgLocaleLocalization;
  _ErrorHandler_19:any;
  _RouterInitializer_20:import8.RouterInitializer;
  _APP_INITIALIZER_21:any[];
  _ApplicationInitStatus_22:import17.ApplicationInitStatus;
  _Testability_23:import18.Testability;
  _ApplicationRef__24:import19.ApplicationRef_;
  __ApplicationRef_25:any;
  __Compiler_26:import20.Compiler;
  __APP_ID_27:any;
  __DOCUMENT_28:any;
  __HAMMER_GESTURE_CONFIG_29:import21.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_30:any[];
  __EventManager_31:import22.EventManager;
  _DomSharedStylesHost_32:import23.DomSharedStylesHost;
  __AnimationDriver_33:any;
  __DomRootRenderer_34:import24.DomRootRenderer_;
  __NgProbeToken_35:any[];
  __RootRenderer_36:any;
  __DomSanitizer_37:import25.DomSanitizerImpl;
  __Sanitizer_38:any;
  __AnimationQueue_39:import26.AnimationQueue;
  __ViewUtils_40:import27.ViewUtils;
  __IterableDiffers_41:any;
  __KeyValueDiffers_42:any;
  __SharedStylesHost_43:any;
  __Title_44:import28.Title;
  __RadioControlRegistry_45:import29.RadioControlRegistry;
  __FormBuilder_46:import30.FormBuilder;
  __BrowserXhr_47:import31.BrowserXhr;
  __ResponseOptions_48:import32.BaseResponseOptions;
  __XSRFStrategy_49:any;
  __XHRBackend_50:import33.XHRBackend;
  __RequestOptions_51:import34.BaseRequestOptions;
  __Http_52:any;
  __ROUTER_CONFIGURATION_53:any;
  __LocationStrategy_54:any;
  __Location_55:import35.Location;
  __UrlSerializer_56:import36.DefaultUrlSerializer;
  __RouterOutletMap_57:import37.RouterOutletMap;
  __NgModuleFactoryLoader_58:import38.SystemJsNgModuleLoader;
  __ROUTES_59:any[];
  __Router_60:any;
  __ActivatedRoute_61:any;
  _NoPreloading_62:import39.NoPreloading;
  _PreloadingStrategy_63:any;
  _RouterPreloader_64:import39.RouterPreloader;
  __PreloadAllModules_65:import39.PreloadAllModules;
  __ROUTER_INITIALIZER_66:any;
  __APP_BOOTSTRAP_LISTENER_67:any[];
  __PositioningService_68:import40.PositioningService;
  __ComponentLoaderFactory_69:import41.ComponentLoaderFactory;
  __ErrorService_70:import42.ErrorService;
  __CommonService_71:import43.CommonService;
  __SpinnerService_72:import44.SpinnerService;
  __CustomHttpService_73:import45.CustomHttpService;
  __LoginService_74:import46.LoginService;
  __ApplicationService_75:import47.ApplicationService;
  __LocalStorageService_76:import48.LocalStorageService;
  __OnlineServiceAuthGuard_77:import49.OnlineServiceAuthGuard;
  __ConfirmationService_78:import50.ConfirmationService;
  __FileValidation_79:import51.FileValidation;
  __InformationService_80:import52.InformationService;
  constructor(parent:import53.Injector) {
    super(parent,[
      import54.ModalBackdropComponentNgFactory,
      import55.AppComponentNgFactory
    ]
    ,[import55.AppComponentNgFactory]);
  }
  get _LOCALE_ID_17():any {
    if ((this.__LOCALE_ID_17 == null)) { (this.__LOCALE_ID_17 = import3._localeFactory(this.parent.get(import56.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_17;
  }
  get _NgLocalization_18():import16.NgLocaleLocalization {
    if ((this.__NgLocalization_18 == null)) { (this.__NgLocalization_18 = new import16.NgLocaleLocalization(this._LOCALE_ID_17)); }
    return this.__NgLocalization_18;
  }
  get _ApplicationRef_25():any {
    if ((this.__ApplicationRef_25 == null)) { (this.__ApplicationRef_25 = this._ApplicationRef__24); }
    return this.__ApplicationRef_25;
  }
  get _Compiler_26():import20.Compiler {
    if ((this.__Compiler_26 == null)) { (this.__Compiler_26 = new import20.Compiler()); }
    return this.__Compiler_26;
  }
  get _APP_ID_27():any {
    if ((this.__APP_ID_27 == null)) { (this.__APP_ID_27 = import57._appIdRandomProviderFactory()); }
    return this.__APP_ID_27;
  }
  get _DOCUMENT_28():any {
    if ((this.__DOCUMENT_28 == null)) { (this.__DOCUMENT_28 = import4._document()); }
    return this.__DOCUMENT_28;
  }
  get _HAMMER_GESTURE_CONFIG_29():import21.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_29 == null)) { (this.__HAMMER_GESTURE_CONFIG_29 = new import21.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_29;
  }
  get _EVENT_MANAGER_PLUGINS_30():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_30 == null)) { (this.__EVENT_MANAGER_PLUGINS_30 = [
      new import58.DomEventsPlugin(),
      new import59.KeyEventsPlugin(),
      new import21.HammerGesturesPlugin(this._HAMMER_GESTURE_CONFIG_29)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_30;
  }
  get _EventManager_31():import22.EventManager {
    if ((this.__EventManager_31 == null)) { (this.__EventManager_31 = new import22.EventManager(this._EVENT_MANAGER_PLUGINS_30,this.parent.get(import60.NgZone))); }
    return this.__EventManager_31;
  }
  get _AnimationDriver_33():any {
    if ((this.__AnimationDriver_33 == null)) { (this.__AnimationDriver_33 = import4._resolveDefaultAnimationDriver()); }
    return this.__AnimationDriver_33;
  }
  get _DomRootRenderer_34():import24.DomRootRenderer_ {
    if ((this.__DomRootRenderer_34 == null)) { (this.__DomRootRenderer_34 = new import24.DomRootRenderer_(this._DOCUMENT_28,this._EventManager_31,this._DomSharedStylesHost_32,this._AnimationDriver_33,this._APP_ID_27)); }
    return this.__DomRootRenderer_34;
  }
  get _NgProbeToken_35():any[] {
    if ((this.__NgProbeToken_35 == null)) { (this.__NgProbeToken_35 = [import8.routerNgProbeToken()]); }
    return this.__NgProbeToken_35;
  }
  get _RootRenderer_36():any {
    if ((this.__RootRenderer_36 == null)) { (this.__RootRenderer_36 = import61._createConditionalRootRenderer(this._DomRootRenderer_34,this.parent.get(import61.NgProbeToken,(null as any)),this._NgProbeToken_35)); }
    return this.__RootRenderer_36;
  }
  get _DomSanitizer_37():import25.DomSanitizerImpl {
    if ((this.__DomSanitizer_37 == null)) { (this.__DomSanitizer_37 = new import25.DomSanitizerImpl()); }
    return this.__DomSanitizer_37;
  }
  get _Sanitizer_38():any {
    if ((this.__Sanitizer_38 == null)) { (this.__Sanitizer_38 = this._DomSanitizer_37); }
    return this.__Sanitizer_38;
  }
  get _AnimationQueue_39():import26.AnimationQueue {
    if ((this.__AnimationQueue_39 == null)) { (this.__AnimationQueue_39 = new import26.AnimationQueue(this.parent.get(import60.NgZone))); }
    return this.__AnimationQueue_39;
  }
  get _ViewUtils_40():import27.ViewUtils {
    if ((this.__ViewUtils_40 == null)) { (this.__ViewUtils_40 = new import27.ViewUtils(this._RootRenderer_36,this._Sanitizer_38,this._AnimationQueue_39)); }
    return this.__ViewUtils_40;
  }
  get _IterableDiffers_41():any {
    if ((this.__IterableDiffers_41 == null)) { (this.__IterableDiffers_41 = import3._iterableDiffersFactory()); }
    return this.__IterableDiffers_41;
  }
  get _KeyValueDiffers_42():any {
    if ((this.__KeyValueDiffers_42 == null)) { (this.__KeyValueDiffers_42 = import3._keyValueDiffersFactory()); }
    return this.__KeyValueDiffers_42;
  }
  get _SharedStylesHost_43():any {
    if ((this.__SharedStylesHost_43 == null)) { (this.__SharedStylesHost_43 = this._DomSharedStylesHost_32); }
    return this.__SharedStylesHost_43;
  }
  get _Title_44():import28.Title {
    if ((this.__Title_44 == null)) { (this.__Title_44 = new import28.Title()); }
    return this.__Title_44;
  }
  get _RadioControlRegistry_45():import29.RadioControlRegistry {
    if ((this.__RadioControlRegistry_45 == null)) { (this.__RadioControlRegistry_45 = new import29.RadioControlRegistry()); }
    return this.__RadioControlRegistry_45;
  }
  get _FormBuilder_46():import30.FormBuilder {
    if ((this.__FormBuilder_46 == null)) { (this.__FormBuilder_46 = new import30.FormBuilder()); }
    return this.__FormBuilder_46;
  }
  get _BrowserXhr_47():import31.BrowserXhr {
    if ((this.__BrowserXhr_47 == null)) { (this.__BrowserXhr_47 = new import31.BrowserXhr()); }
    return this.__BrowserXhr_47;
  }
  get _ResponseOptions_48():import32.BaseResponseOptions {
    if ((this.__ResponseOptions_48 == null)) { (this.__ResponseOptions_48 = new import32.BaseResponseOptions()); }
    return this.__ResponseOptions_48;
  }
  get _XSRFStrategy_49():any {
    if ((this.__XSRFStrategy_49 == null)) { (this.__XSRFStrategy_49 = import7._createDefaultCookieXSRFStrategy()); }
    return this.__XSRFStrategy_49;
  }
  get _XHRBackend_50():import33.XHRBackend {
    if ((this.__XHRBackend_50 == null)) { (this.__XHRBackend_50 = new import33.XHRBackend(this._BrowserXhr_47,this._ResponseOptions_48,this._XSRFStrategy_49)); }
    return this.__XHRBackend_50;
  }
  get _RequestOptions_51():import34.BaseRequestOptions {
    if ((this.__RequestOptions_51 == null)) { (this.__RequestOptions_51 = new import34.BaseRequestOptions()); }
    return this.__RequestOptions_51;
  }
  get _Http_52():any {
    if ((this.__Http_52 == null)) { (this.__Http_52 = import7.httpFactory(this._XHRBackend_50,this._RequestOptions_51)); }
    return this.__Http_52;
  }
  get _ROUTER_CONFIGURATION_53():any {
    if ((this.__ROUTER_CONFIGURATION_53 == null)) { (this.__ROUTER_CONFIGURATION_53 = {useHash: true}); }
    return this.__ROUTER_CONFIGURATION_53;
  }
  get _LocationStrategy_54():any {
    if ((this.__LocationStrategy_54 == null)) { (this.__LocationStrategy_54 = import8.provideLocationStrategy(this.parent.get(import62.PlatformLocation),this.parent.get(import63.APP_BASE_HREF,(null as any)),this._ROUTER_CONFIGURATION_53)); }
    return this.__LocationStrategy_54;
  }
  get _Location_55():import35.Location {
    if ((this.__Location_55 == null)) { (this.__Location_55 = new import35.Location(this._LocationStrategy_54)); }
    return this.__Location_55;
  }
  get _UrlSerializer_56():import36.DefaultUrlSerializer {
    if ((this.__UrlSerializer_56 == null)) { (this.__UrlSerializer_56 = new import36.DefaultUrlSerializer()); }
    return this.__UrlSerializer_56;
  }
  get _RouterOutletMap_57():import37.RouterOutletMap {
    if ((this.__RouterOutletMap_57 == null)) { (this.__RouterOutletMap_57 = new import37.RouterOutletMap()); }
    return this.__RouterOutletMap_57;
  }
  get _NgModuleFactoryLoader_58():import38.SystemJsNgModuleLoader {
    if ((this.__NgModuleFactoryLoader_58 == null)) { (this.__NgModuleFactoryLoader_58 = new import38.SystemJsNgModuleLoader(this._Compiler_26,this.parent.get(import38.SystemJsNgModuleLoaderConfig,(null as any)))); }
    return this.__NgModuleFactoryLoader_58;
  }
  get _ROUTES_59():any[] {
      if ((this.__ROUTES_59 == null)) { (this.__ROUTES_59 = [[
        {
          path: 'welcome',
          loadChildren: 'app/welcome/welcome.module#WelcomeModule'
        }
        ,
        {
          path: 'login',
          loadChildren: 'app/login/login.module#LoginModule'
        }
        ,
        {
          path: 'information',
          loadChildren: 'app/information/information.module#InformationModule'
        }
        ,
        {
          path: 'createuser',
          loadChildren: 'app/createuser/createuser.module#CreateUserModule'
        }
        ,
        {
          path: 'application',
          loadChildren: 'app/application/application.module#ApplicationModule',
          canActivate: [import49.OnlineServiceAuthGuard]
        }
        ,
        {
          path: '',
          redirectTo: '/welcome',
          pathMatch: 'full'
        }

      ]
    ]); }
    return this.__ROUTES_59;
  }
  get _Router_60():any {
    if ((this.__Router_60 == null)) { (this.__Router_60 = import8.setupRouter(this._ApplicationRef_25,this._UrlSerializer_56,this._RouterOutletMap_57,this._Location_55,this,this._NgModuleFactoryLoader_58,this._Compiler_26,this._ROUTES_59,this._ROUTER_CONFIGURATION_53,this.parent.get(import64.UrlHandlingStrategy,(null as any)),this.parent.get(import65.RouteReuseStrategy,(null as any)))); }
    return this.__Router_60;
  }
  get _ActivatedRoute_61():any {
    if ((this.__ActivatedRoute_61 == null)) { (this.__ActivatedRoute_61 = import8.rootRoute(this._Router_60)); }
    return this.__ActivatedRoute_61;
  }
  get _PreloadAllModules_65():import39.PreloadAllModules {
    if ((this.__PreloadAllModules_65 == null)) { (this.__PreloadAllModules_65 = new import39.PreloadAllModules()); }
    return this.__PreloadAllModules_65;
  }
  get _ROUTER_INITIALIZER_66():any {
    if ((this.__ROUTER_INITIALIZER_66 == null)) { (this.__ROUTER_INITIALIZER_66 = import8.getBootstrapListener(this._RouterInitializer_20)); }
    return this.__ROUTER_INITIALIZER_66;
  }
  get _APP_BOOTSTRAP_LISTENER_67():any[] {
    if ((this.__APP_BOOTSTRAP_LISTENER_67 == null)) { (this.__APP_BOOTSTRAP_LISTENER_67 = [this._ROUTER_INITIALIZER_66]); }
    return this.__APP_BOOTSTRAP_LISTENER_67;
  }
  get _PositioningService_68():import40.PositioningService {
    if ((this.__PositioningService_68 == null)) { (this.__PositioningService_68 = new import40.PositioningService()); }
    return this.__PositioningService_68;
  }
  get _ComponentLoaderFactory_69():import41.ComponentLoaderFactory {
    if ((this.__ComponentLoaderFactory_69 == null)) { (this.__ComponentLoaderFactory_69 = new import41.ComponentLoaderFactory(this,this.parent.get(import60.NgZone),this,this._PositioningService_68)); }
    return this.__ComponentLoaderFactory_69;
  }
  get _ErrorService_70():import42.ErrorService {
    if ((this.__ErrorService_70 == null)) { (this.__ErrorService_70 = new import42.ErrorService()); }
    return this.__ErrorService_70;
  }
  get _CommonService_71():import43.CommonService {
    if ((this.__CommonService_71 == null)) { (this.__CommonService_71 = new import43.CommonService()); }
    return this.__CommonService_71;
  }
  get _SpinnerService_72():import44.SpinnerService {
    if ((this.__SpinnerService_72 == null)) { (this.__SpinnerService_72 = new import44.SpinnerService()); }
    return this.__SpinnerService_72;
  }
  get _CustomHttpService_73():import45.CustomHttpService {
    if ((this.__CustomHttpService_73 == null)) { (this.__CustomHttpService_73 = new import45.CustomHttpService(this._Http_52,this._ErrorService_70,this._CommonService_71,this._SpinnerService_72,this._Router_60)); }
    return this.__CustomHttpService_73;
  }
  get _LoginService_74():import46.LoginService {
    if ((this.__LoginService_74 == null)) { (this.__LoginService_74 = new import46.LoginService(this._CustomHttpService_73)); }
    return this.__LoginService_74;
  }
  get _ApplicationService_75():import47.ApplicationService {
    if ((this.__ApplicationService_75 == null)) { (this.__ApplicationService_75 = new import47.ApplicationService(this._CustomHttpService_73)); }
    return this.__ApplicationService_75;
  }
  get _LocalStorageService_76():import48.LocalStorageService {
    if ((this.__LocalStorageService_76 == null)) { (this.__LocalStorageService_76 = new import48.LocalStorageService(this._ApplicationService_75)); }
    return this.__LocalStorageService_76;
  }
  get _OnlineServiceAuthGuard_77():import49.OnlineServiceAuthGuard {
    if ((this.__OnlineServiceAuthGuard_77 == null)) { (this.__OnlineServiceAuthGuard_77 = new import49.OnlineServiceAuthGuard(this._Router_60,this._LocalStorageService_76)); }
    return this.__OnlineServiceAuthGuard_77;
  }
  get _ConfirmationService_78():import50.ConfirmationService {
    if ((this.__ConfirmationService_78 == null)) { (this.__ConfirmationService_78 = new import50.ConfirmationService()); }
    return this.__ConfirmationService_78;
  }
  get _FileValidation_79():import51.FileValidation {
    if ((this.__FileValidation_79 == null)) { (this.__FileValidation_79 = new import51.FileValidation()); }
    return this.__FileValidation_79;
  }
  get _InformationService_80():import52.InformationService {
    if ((this.__InformationService_80 == null)) { (this.__InformationService_80 = new import52.InformationService(this._CustomHttpService_73)); }
    return this.__InformationService_80;
  }
  createInternal():import1.AppModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._ApplicationModule_1 = new import3.ApplicationModule();
    this._BrowserModule_2 = new import4.BrowserModule(this.parent.get(import4.BrowserModule,(null as any)));
    this._InternalFormsSharedModule_3 = new import5.InternalFormsSharedModule();
    this._FormsModule_4 = new import6.FormsModule();
    this._ReactiveFormsModule_5 = new import6.ReactiveFormsModule();
    this._HttpModule_6 = new import7.HttpModule();
    this._ROUTER_FORROOT_GUARD_7 = import8.provideForRootGuard(this.parent.get(import66.Router,(null as any)));
    this._RouterModule_8 = new import8.RouterModule(this._ROUTER_FORROOT_GUARD_7);
    this._AppRoutingModule_9 = new import9.AppRoutingModule();
    this._GrowlModule_10 = new import10.GrowlModule();
    this._ModalModule_11 = new import11.ModalModule();
    this._InputTextModule_12 = new import12.InputTextModule();
    this._ButtonModule_13 = new import13.ButtonModule();
    this._SharedModule_14 = new import14.SharedModule();
    this._AutoCompleteModule_15 = new import15.AutoCompleteModule();
    this._AppModule_16 = new import1.AppModule();
    this._ErrorHandler_19 = import4.errorHandler();
    this._RouterInitializer_20 = new import8.RouterInitializer(this);
    this._APP_INITIALIZER_21 = [import8.getAppInitializer(this._RouterInitializer_20)];
    this._ApplicationInitStatus_22 = new import17.ApplicationInitStatus(this._APP_INITIALIZER_21);
    this._Testability_23 = new import18.Testability(this.parent.get(import60.NgZone));
    this._ApplicationRef__24 = new import19.ApplicationRef_(this.parent.get(import60.NgZone),this.parent.get(import67.Console),this,this._ErrorHandler_19,this,this._ApplicationInitStatus_22,this.parent.get(import18.TestabilityRegistry,(null as any)),this._Testability_23);
    this._DomSharedStylesHost_32 = new import23.DomSharedStylesHost(this._DOCUMENT_28);
    this._NoPreloading_62 = new import39.NoPreloading();
    this._PreloadingStrategy_63 = this._NoPreloading_62;
    this._RouterPreloader_64 = new import39.RouterPreloader(this._Router_60,this._NgModuleFactoryLoader_58,this._Compiler_26,this,this._PreloadingStrategy_63);
    return this._AppModule_16;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import3.ApplicationModule)) { return this._ApplicationModule_1; }
    if ((token === import4.BrowserModule)) { return this._BrowserModule_2; }
    if ((token === import5.InternalFormsSharedModule)) { return this._InternalFormsSharedModule_3; }
    if ((token === import6.FormsModule)) { return this._FormsModule_4; }
    if ((token === import6.ReactiveFormsModule)) { return this._ReactiveFormsModule_5; }
    if ((token === import7.HttpModule)) { return this._HttpModule_6; }
    if ((token === import8.ROUTER_FORROOT_GUARD)) { return this._ROUTER_FORROOT_GUARD_7; }
    if ((token === import8.RouterModule)) { return this._RouterModule_8; }
    if ((token === import9.AppRoutingModule)) { return this._AppRoutingModule_9; }
    if ((token === import10.GrowlModule)) { return this._GrowlModule_10; }
    if ((token === import11.ModalModule)) { return this._ModalModule_11; }
    if ((token === import12.InputTextModule)) { return this._InputTextModule_12; }
    if ((token === import13.ButtonModule)) { return this._ButtonModule_13; }
    if ((token === import14.SharedModule)) { return this._SharedModule_14; }
    if ((token === import15.AutoCompleteModule)) { return this._AutoCompleteModule_15; }
    if ((token === import1.AppModule)) { return this._AppModule_16; }
    if ((token === import56.LOCALE_ID)) { return this._LOCALE_ID_17; }
    if ((token === import16.NgLocalization)) { return this._NgLocalization_18; }
    if ((token === import68.ErrorHandler)) { return this._ErrorHandler_19; }
    if ((token === import8.RouterInitializer)) { return this._RouterInitializer_20; }
    if ((token === import17.APP_INITIALIZER)) { return this._APP_INITIALIZER_21; }
    if ((token === import17.ApplicationInitStatus)) { return this._ApplicationInitStatus_22; }
    if ((token === import18.Testability)) { return this._Testability_23; }
    if ((token === import19.ApplicationRef_)) { return this._ApplicationRef__24; }
    if ((token === import19.ApplicationRef)) { return this._ApplicationRef_25; }
    if ((token === import20.Compiler)) { return this._Compiler_26; }
    if ((token === import57.APP_ID)) { return this._APP_ID_27; }
    if ((token === import69.DOCUMENT)) { return this._DOCUMENT_28; }
    if ((token === import21.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_29; }
    if ((token === import22.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_30; }
    if ((token === import22.EventManager)) { return this._EventManager_31; }
    if ((token === import23.DomSharedStylesHost)) { return this._DomSharedStylesHost_32; }
    if ((token === import70.AnimationDriver)) { return this._AnimationDriver_33; }
    if ((token === import24.DomRootRenderer)) { return this._DomRootRenderer_34; }
    if ((token === import19.NgProbeToken)) { return this._NgProbeToken_35; }
    if ((token === import71.RootRenderer)) { return this._RootRenderer_36; }
    if ((token === import25.DomSanitizer)) { return this._DomSanitizer_37; }
    if ((token === import72.Sanitizer)) { return this._Sanitizer_38; }
    if ((token === import26.AnimationQueue)) { return this._AnimationQueue_39; }
    if ((token === import27.ViewUtils)) { return this._ViewUtils_40; }
    if ((token === import73.IterableDiffers)) { return this._IterableDiffers_41; }
    if ((token === import74.KeyValueDiffers)) { return this._KeyValueDiffers_42; }
    if ((token === import23.SharedStylesHost)) { return this._SharedStylesHost_43; }
    if ((token === import28.Title)) { return this._Title_44; }
    if ((token === import29.RadioControlRegistry)) { return this._RadioControlRegistry_45; }
    if ((token === import30.FormBuilder)) { return this._FormBuilder_46; }
    if ((token === import31.BrowserXhr)) { return this._BrowserXhr_47; }
    if ((token === import32.ResponseOptions)) { return this._ResponseOptions_48; }
    if ((token === import75.XSRFStrategy)) { return this._XSRFStrategy_49; }
    if ((token === import33.XHRBackend)) { return this._XHRBackend_50; }
    if ((token === import34.RequestOptions)) { return this._RequestOptions_51; }
    if ((token === import76.Http)) { return this._Http_52; }
    if ((token === import8.ROUTER_CONFIGURATION)) { return this._ROUTER_CONFIGURATION_53; }
    if ((token === import63.LocationStrategy)) { return this._LocationStrategy_54; }
    if ((token === import35.Location)) { return this._Location_55; }
    if ((token === import36.UrlSerializer)) { return this._UrlSerializer_56; }
    if ((token === import37.RouterOutletMap)) { return this._RouterOutletMap_57; }
    if ((token === import77.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_58; }
    if ((token === import78.ROUTES)) { return this._ROUTES_59; }
    if ((token === import66.Router)) { return this._Router_60; }
    if ((token === import79.ActivatedRoute)) { return this._ActivatedRoute_61; }
    if ((token === import39.NoPreloading)) { return this._NoPreloading_62; }
    if ((token === import39.PreloadingStrategy)) { return this._PreloadingStrategy_63; }
    if ((token === import39.RouterPreloader)) { return this._RouterPreloader_64; }
    if ((token === import39.PreloadAllModules)) { return this._PreloadAllModules_65; }
    if ((token === import8.ROUTER_INITIALIZER)) { return this._ROUTER_INITIALIZER_66; }
    if ((token === import57.APP_BOOTSTRAP_LISTENER)) { return this._APP_BOOTSTRAP_LISTENER_67; }
    if ((token === import40.PositioningService)) { return this._PositioningService_68; }
    if ((token === import41.ComponentLoaderFactory)) { return this._ComponentLoaderFactory_69; }
    if ((token === import42.ErrorService)) { return this._ErrorService_70; }
    if ((token === import43.CommonService)) { return this._CommonService_71; }
    if ((token === import44.SpinnerService)) { return this._SpinnerService_72; }
    if ((token === import45.CustomHttpService)) { return this._CustomHttpService_73; }
    if ((token === import46.LoginService)) { return this._LoginService_74; }
    if ((token === import47.ApplicationService)) { return this._ApplicationService_75; }
    if ((token === import48.LocalStorageService)) { return this._LocalStorageService_76; }
    if ((token === import49.OnlineServiceAuthGuard)) { return this._OnlineServiceAuthGuard_77; }
    if ((token === import50.ConfirmationService)) { return this._ConfirmationService_78; }
    if ((token === import51.FileValidation)) { return this._FileValidation_79; }
    if ((token === import52.InformationService)) { return this._InformationService_80; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ApplicationRef__24.ngOnDestroy();
    this._DomSharedStylesHost_32.ngOnDestroy();
    this._RouterPreloader_64.ngOnDestroy();
  }
}
export const AppModuleNgFactory:import0.NgModuleFactory<import1.AppModule> = new import0.NgModuleFactory(AppModuleInjector,import1.AppModule);


// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts